import { useEffect } from 'react'
import { WebsocketEvent } from 'entities/WebSocket'
import { type IResponseSubscription } from 'entities/Subscription/api/types'
import { useEntitiesContext } from 'entities/EntitiesExport'

export const useEventSubscriptionUpdated = () => {
  const { subscriptionStore, websocket } = useEntitiesContext()

  const handle = (data: IResponseSubscription) => {
    subscriptionStore.syncFromEvent(data)
  }

  useEffect(() => {
    websocket.on(WebsocketEvent.SubscriptionUpdated, handle)

    return () => websocket.off(WebsocketEvent.SubscriptionUpdated, handle)
  }, [])
}
